//
// Module for the Employment Edit view
//
rs.module("participant/member/employment/edit",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, updatePlanListUrl, isNewEmployment) {

            var employmentCard = $.js(jsSelectors.employmentCard);

            // Get Select Helper for planSelect since we're updating its options and properties
            var planSelectHelper = selectHelper.getHelper(employmentCard.js(jsSelectors.planSelect));

            employmentCard.js(jsSelectors.employerSelect).change(function () {
                var employerKey = this.value;

                planSelectHelper.loadOptionsFrom(updatePlanListUrl, { employerKey }, { withBlank: true });
            });

            if (isNewEmployment) {

                employmentCard.js(jsSelectors.hireDatePicker).change(function () {
                    var hireDate = this.value;

                    if (hireDate !== "") {
                        employmentCard.js(jsSelectors.participationDatePicker).val(hireDate);
                        employmentCard.js(jsSelectors.contributionDatePicker).val(hireDate);
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);